import { useSyncExternalStore } from 'react'
import { Link, useLogout } from 'react-admin'
import { CircularProgress } from '@mui/material'

import { authErrorStore } from '../supabase/customAuthProvider'

const LoadingPage = () => {
  const logout = useLogout()
  const authError = useSyncExternalStore(authErrorStore.subscribe, authErrorStore.getSnapshot)

  if (authError) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px',
          textAlign: 'center',
          fontSize: '1.25rem',
        }}>
          <p style={{ color: '#d32f2f', fontSize: '1.25rem' }}>{authError}</p>

          <span style={{ marginTop: '40px', fontSize: '1rem' }}>
            Merci de <Link onClick={logout}>vous déconnecter</Link>.
          </span>
        </div>
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
        textAlign: 'center',
        fontSize: '1.25rem',
      }}>
        <h1 style={{ color: '#74a5b5' }}>Chargement en cours...</h1>

        <CircularProgress />

        <span style={{ marginTop: '40px', fontSize: '1rem' }}>
          Si la page est trop longue à charger,
          merci de <Link onClick={logout}>vous déconnecter</Link>.
        </span>
      </div>
    </div>
  )
}

export default LoadingPage
